export default {
    data() {
        return {
            dirty: false,
            valid: null,
            rules: null,
            defaultErrorMessage: 'Данное поле заполнено некорректно',
        };
    },
    computed: {
        invalid() {
            return this.valid === false; // начальное значение this.valid = null
        },
    },
    methods: {
        async checkValidation(value, rules) {
            const validationKeys = Object.keys(rules || {});

            if (!validationKeys.length) {
                return {
                    valid: true,
                    rules: [],
                };
            }

            const promises = validationKeys.map(async key => ({
                rule: key,
                valid: typeof rules[key] === 'function'
                    ? Boolean(await rules[key](value))
                    : Boolean(await rules[key].handler(value)),
            }));

            const res = await Promise.all(promises);

            return {
                valid: res.every(item => item.valid),
                rules: res,
            };
        },
        /**
         * @public
         * Метод для ручной валидации.
         * Возвращает результат в виде объекта с полями `valid` и `rules`.
         */
        async validate(value = this.value, rules = this.validationRules) {
            const initialValid = this.valid;
            const result = await this.checkValidation(value, rules);

            this.valid = result.valid;
            this.rules = result.rules;

            if (!this.valid) {
                /**
                 * Эмит события `invalid` с перечислением применяемых правил и их состоянием валидности
                 */
                this.$emit('invalid', {
                    rules: result.rules,
                    value,
                });
            } else if (this.valid !== initialValid) {
                /**
                 * Эмит события `valid`, означает, что все правила прошли проверку валидации
                 */
                this.$emit('valid');
            }

            return result;
        },
        /**
         * @public
         * Метод для ручного сброса состояния валидации.
         */
        resetValidation() {
            this.dirty = false;
            this.valid = null;
            this.rules = null;
        },
    },
    props: {
        /**
         * Не валидировать компонент по событиям `blur` и `input`.
         * Можно запустить валидацию вручную с помощью метода `validate`
         *
         * @example `this.$refs.textarea.validate()`
         */
        noValidate: {
            type: Boolean,
            default: false,
        },
        /**
         * Список правил валидации
         */
        validationRules: {
            type: Object,
            default: () => ({}),
        },
    },
};
